import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppLogo from "../components/AppLogo";
import { useDispatch, useSelector } from "react-redux";
import { APP_VERSION } from "../constant";
import { useApiCall } from "../services/api";
import { setCounts } from "../redux/auth/navCountSlice";
import { setOfferShown } from "../redux/auth/loginSlice";
import Title from "antd/es/typography/Title";
import Paragraph from "antd/es/typography/Paragraph";
import Text from "antd/es/typography/Text";
import { Alert, Button } from "antd";
import { TbInfoCircleFilled } from "react-icons/tb";

const ForceUpdate = () => {
  const navigate = useNavigate();
  const { appVersion } = useSelector((state) => state.navCounts);
  const { getApi } = useApiCall();
  const dispatch = useDispatch();

  useEffect(() => {
    const verifySystemVersion = async () => {
      try {
        const response = await getApi("sales/common/app-version");

        const data = response?.data;

        if (data?.web_version === APP_VERSION) {
          dispatch(setOfferShown(false));
          navigate("/");
        }

        dispatch(setCounts({ appVersion: data?.web_version || APP_VERSION }));
      } catch (error) {
        console.error("Version verification failed:", error);
      }
    };

    verifySystemVersion();
  }, [navigate, appVersion]);

  return (
    <div className="container-full">
      <div
        className="h-full min-h-screen"
        style={{
          backgroundImage: "linear-gradient(180deg, #FFDBD4 36.74%, #F4F4F4 95.35%)",
        }}
      >
        <div className="flex py-6 justify-center items-center">
          <AppLogo />
        </div>

        <div className="flex flex-col py-32 justify-between items-center">
          <div>
            <img src="/assets/images/block.svg" className="w-full" alt="logo" />
          </div>

          <div className="flex flex-col justify-between items-center text-center">
            <div className="flex flex-col items-center text-center max-w-xl px-6">
              <Title level={2} className="!mb-3 !font-normal !text-primary">
                Update Required
              </Title>

              <Paragraph className="!text-text-secondary !text-base">
                A new version of the platform is available. Please refresh your browser to load the latest updates and continue using the system.
              </Paragraph>

              <Alert
                className="w-full sm:w-[75%] mt-4 text-left"
                type="info"
                showIcon
                style={{
                  background: "rgba(255,255,255,0.65)",
                  borderColor: "rgba(200,74,46,0.2)",
                }}
                icon={
                  <TbInfoCircleFilled
                    style={{
                      color: "#A33434",
                    }}
                  />
                }
                message="How to refresh your browser"
                description={
                  <div className="space-y-3 mt-2">
                    <div className="leading-loose">
                      <Text strong>Windows:</Text>
                      <br />
                      Press <Text keyboard>Ctrl</Text> + <Text keyboard>F5</Text>
                      <br /> or <Text keyboard>Ctrl</Text> + <Text keyboard>Shift</Text> + <Text keyboard>R</Text>
                    </div>

                    <div className="leading-loose">
                      <Text strong>Mac:</Text>
                      <br />
                      Press <Text keyboard>⌘ Cmd</Text> + <Text keyboard>Shift</Text> + <Text keyboard>R</Text>
                      <br /> or <Text keyboard>⌘ Cmd</Text> + <Text keyboard>Option</Text> + <Text keyboard>R</Text>
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForceUpdate;
